import type Router from "vue-router"
import Routing from "@/store/session/routing"
import {isSameRoute} from "@/plugins/routerUtilities"

export default function(router: Router): void {
	router.beforeEach((to, from, next) => {
		if (!isSameRoute(to, from))
			Routing.setRoutingStatus("routing")
		next()
	})

	router.afterEach((to, from) => {
		Routing.routeComplete()
	})
}
